export const ENDPOINTS = {
    RUNS: '/external-dashboard/workspaces/:workspaceId/workflows/executions',
    RUNS_STATS: '/external-dashboard/workspaces/:workspaceId/workflows/executions/stats',
    RUN_DETAILS: '/external-dashboard/workspaces/:workspaceId/workflows/executions/:runId',
    RUN_CANCEL: '/external-dashboard/workspaces/:workspaceId/workflows/:runId/cancel',
    RUN_RESULTS: '/external-dashboard/workspaces/:workspaceId/workflows/:runId/result',
    WORKFLOWS_RUN: '/external-dashboard/workspaces/:workspaceId/workflows/run',
    WORKFLOW_RUN: '/external-dashboard/workspaces/:workspaceId/workflows/:workflowId',
    WORKFLOWS: '/external-dashboard/workspaces/:workspaceId/workflows',
}
